/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { useEffect } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { AuthPage, SSOPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import CallbackPage from "./pages/callback/CallbackPage";
import SignoutCallbackPage from "./pages/callback/SignoutCallbackPage";
import { SilentRenewComponent } from "./pages/silent_renew/SilentRenewComponent";
import LayoutBase from "./core/components/layout/LayoutBase";
export default function Routes(props) {
    const { isAuthorized } = useSelector(
        ({ auth }) => ({
            isAuthorized: auth.user != null,
        }),
        shallowEqual
    );

    return (
        <Switch>
            <Route
                exact={true}
                path={"/silent_renew"}
                component={SilentRenewComponent}
            />
            <Route path="/callback" component={CallbackPage} />
            <Route path="/sso" component={SSOPage} />
            <Route path="/logout" component={SignoutCallbackPage} />
            {!isAuthorized ? (
                /*Render auth page when user at `/auth` and not authorized.*/
                <Route>
                    <AuthPage />
                </Route>
            ) : (
                /*Otherwise redirect to root page (`/`)*/
                <Redirect from="/auth" to="/" />
            )}

            <Route path="/error" component={ErrorsPage} />

            {/* <Route path="/logout" component={Logout} /> */}

            {!isAuthorized ? (
                /*Redirect to `/auth` when user is not authorized*/
                <Redirect to="/auth/login" />
            ) : (
                <>
                    {
                        <LayoutBase>
                            <BasePage />
                        </LayoutBase>
                    }
                </>
            )}
        </Switch>
    );
}
